import React from "react";
import styled from "styled-components";

const Container = styled.div``;

const Home = () => {
	return (
		<Container>
			<h1>Welcome to the Candidate Admin System</h1>
		</Container>
	);
};
export default Home;
